import { gql } from '@edreamsodigeo/frontend-api-client';

export const FLIGHT_SUMMARY_SELECTED_TOTAL_PRICE = gql`
  query GetFlightSummarySelectedTotalPrice($request: ShoppingSummaryRequest!) {
    getSummaryPrice(request: $request) {
      ... on ItineraryPriceSummary {
        pricePerPassenger {
          amount
          currency
        }
        nonDiscountedPricePerPassenger {
          amount
          currency
        }
      }
    }
  }
`;
